var SpriteSymbol = require("../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "fa-caret-down",
  "use": "fa-caret-down-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"fa-caret-down\">\n<path d=\"M14.9064 7.53516C15.5861 7.53516 15.9259 8.35547 15.4455 8.83594L10.5392 13.7422C10.2424 14.0391 9.75798 14.0391 9.4611 13.7422L4.55095 8.83594C4.07048 8.35547 4.41032 7.53516 5.09001 7.53516H14.9064Z\" fill=\"#424242\" />\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id